import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../Footer';
import { toast } from 'react-toastify';

import axios from 'axios';
import config from '../../function/config';
import Usernav from '../UserHome/Usernav';
import AdminNav from '../Admin/AdminHome/AdminNav';
import HomeNav from '../Navbars/HomeNav';

export default function AutomationRegisterLogistics() {

  
const [isScrolled, setIsScrolled] = useState(false);
 useEffect(() => {
        const handleScroll = () => {
          setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
      
  // Scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
      
        
        const navigate = useNavigate()
        
          

          const [formType, setFormType] = useState("sale"); // Default to "sale"
          const [loading,setLoading] = useState(false)
          const[Title,setTitle] = useState('')
          const[vesselType,setvesselType] = useState('')
          const[ShortDescription,setShortDescription] = useState('')
          const[Flag,setFlag] = useState('')
          const[YearBuilt,setYearBuilt] = useState('')
          const[Capacity,setCapacity] = useState('')
          const[LOA,setLOA] = useState('')
          const[Class,setClass] = useState('')
          const[GRTNRT,setGRTNRT] = useState('')
          const[Teu,setTeu] = useState('')
          const[Price,setPrice] = useState('')
          const[MainEngine,setMainEngine] = useState('')
          const[DWT,setDWT] = useState('')

          const[Email,setEmail] = useState('')
          const[MobileNO,setMobileNO] = useState('')
          const[BriefDescription,setBriefDescription] = useState('')
          const [images, setImages] = useState([]);
          const [ThumbnailImage, setThumbnailImage] = useState("");
          const [Image,setImage] = useState('')
          const [Nationality,setNationality] = useState('')
          const [BuyAsScrap,setBuyAsScrap] = useState('')
          const [From,setFrom] = useState('')
          const [To,setTo] = useState('')
          const [InspectionCountry,setInspectionCountry] = useState('')

          const [Category,setCategory] = useState('')
          const [Subject,setSubject] = useState('')

          

          const [count,setCount] = useState(0)


         const [selectedImages, setSelectedImages] = useState([]); // Array of { file, preview }
         
         const handleImageChange = (e) => {
           const files = Array.from(e.target.files);
           const newImages = files.slice(0, 3 - images.length).map((file) => ({
             file,
             preview: URL.createObjectURL(file),
           }));
         
           setImages((prevImages) => [...prevImages, ...newImages]);
         };
         
         const removeImage = (index) => {
           const updated = [...images];
           updated.splice(index, 1);
           setImages(updated);
         };
          
         
        

      const [user,setUser] = useState(null)
        const token = localStorage.getItem('token')

    
    useEffect(() => {
        async function fetchdata() {
          try {
            const res2 = await axios.get(
              `${config.base_url}/api/HappyMarineShipping/viewusers`,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Token ${token}`,
                },
              }
            );
            console.log("API response:", res2.data);
            if (res2.data.status === 200) {
              console.log("User:",res2);
              setUser(res2.data.data);
            } else {
              console.log(res2);
            }
          } catch (error) {
            console.log(error);
          }
        }
        fetchdata();
      }, [ token]);

     

        const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const [CompanyAddress,setCompanyAddress] = useState('');
    const [Company,setCompany] = useState('');
    const [name,setName] = useState('');
    const [Lychan,setLychan] = useState('');
    const [TypeOfCargo,setTypeOfCargo] = useState('')
    const [Tonnage,setTonnage] = useState('')
    const [LoadingPort,setLoadingPort] = useState('')
    const [DischargePort,setDischargePort] = useState('')
    const [ChartererAcc,setChartererAcc] = useState('')
    const [Commission,setCommission] = useState('')
    const userId = localStorage.getItem("userId");
    const [Url, setUrl] = useState("");
    

    const handleSubmitCharter = async (e, id) => {
        e.preventDefault();
        setLoading(true);
    
        const formData = new FormData();
    
        // Append text fields
        formData.append("type_of_cargo", TypeOfCargo);
        formData.append("user", userId);
        formData.append("url_new", Url);
        formData.append("tonnage", Tonnage);
        formData.append("loading_port", LoadingPort);
        formData.append("discharge_port", DischargePort);
        formData.append("lychan", Lychan);
        formData.append("email", Email);
        formData.append("phone", MobileNO);
        formData.append("brief_description", BriefDescription);
        formData.append("name", name);
        formData.append("company_address", CompanyAddress);
        formData.append("company", Company);
        formData.append("charterer_account", ChartererAcc);
        formData.append("commission", Commission);
        
    
        
    
        try {
          const response = await axios.post(
            `https://marinizbackend.mariniz.com/api/HappyMarineShipping/RegisterLogistics`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
              },
            }
          );
          console.log("API Response:", response.data);
          if (response.data.status === 200) {
            navigate("/regShip");
            setLoading(false);
            toast.success("Registered Successfully!", {
              autoClose: 1500,
              position: "top-right",
            });
    
            // Reset form state
            setCount(id);
           
          } else {
            setLoading(false);
            toast.error("Fill the  Fields", {
              autoClose: 1500,
              position: "top-right",
            });
          }
        } catch (err) {
          setLoading(false);
          console.error("Error:", err);
          toast.error("Error", {
            autoClose: 2000,
            position: "top-right",
          });
        }
      };
        
  return (
    <div className='bg-gradient-to-r from-[#2e5775] to-[#326e99] '>

        {user ? (user.is_superuser ? <AdminNav /> :  <Usernav />) : <HomeNav/>}

        <section className='mt-14 mb-10'> 
        <div className="py-10 px-[30px] xm:px-[10px] w-[80%] lg:w-[90%] m-auto border rounded border-white">
            
      {/* Links for selecting form type */}
      <div className="flex justify-center gap-8 lg:flex-wrap lg:gap-5 items-center">
        
        <button
          
           className='text-white text-2xl mb-3 font-bold'
        >
          Register Logistics
        </button>
        
        
      </div>

    <Link to={'/regShip'} className='px-3  text-white'><i className='fa-solid fa-beat fa-arrow-left '></i> Back</Link>
      

      {/* Conditional Form Rendering */}
        <form className="bg-white mt-2 rounded w-[100%]">
            <div className="p-5">
              <h1 className="text-black font-bold text-xl">
                Register Cargo
              </h1>
            </div>
            <hr className="text-gray-100 w-full" />
            {/* vessel type */}
            <div className="p-5 flex gap-5 items-center xm:flex-wrap xm:gap-5">
              <div className=" w-[100%]">
                <label htmlFor="VesselType" className="font-semibold">
                  Type Of Cargo
                </label>
                <input
      value={TypeOfCargo}
      onChange={(e)=> setTypeOfCargo(e.target.value)}
      className="w-full mt-3 rounded border border-gray-400 p-2 text-gray-500"
      id="GeneratedCode"
      placeholder="Enter type Of Cargo "
    />
              </div>

              <div className="w-[50%] xm:w-[100%]">
    <label className="font-bold" htmlFor="GeneratedCode">Tonnage</label>
    <input
      value={Tonnage}
      onChange={(e)=> setTonnage(e.target.value)}
      className="w-full mt-3 rounded border border-gray-400 p-2 text-gray-500"
      id="GeneratedCode"
      placeholder="Enter Tonnage "
    />
  </div>
            </div>
            {/* DWT */}

            {/* nationality and inspection */}
            <div className="p-5 flex justify-between xm:flex-wrap gap-5 items-center">
              {/* Custom Dropdown for Open Area */}
              <div className="relative w-[50%] xm:w-full">
                <label htmlFor="DWT" className="font-semibold">
                  Loading Port
                </label>
                <input
                  value={LoadingPort}
                  placeholder="Enter the Loading Port"
                  onChange={(e) => setLoadingPort(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400 text-gray-500 p-2"
                  id="DWT"
                />

                
              </div>

              {/* DWT */}
              <div className="xm:w-full w-[50%]">
                <label htmlFor="DWT" className="font-semibold">
                  Discharge Port
                </label>
                <input
                  value={DischargePort}
                  placeholder="Enter the Discharge Port"
                  onChange={(e) => setDischargePort(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400 text-gray-500 p-2"
                  id="DWT"
                />
              </div>
            </div>

           {/* Year of Built */}
            <div className="p-5 flex justify-between xm:flex-wrap gap-5 items-center ">
              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Year Of Built" className="font-semibold">
                  Lychan
                </label>
               <input
                  value={Lychan}
                  placeholder="Enter Lychan"
                  onChange={(e) => setLychan(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Year Of Built"
                />
              </div>
              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Year Of Built" className="font-semibold">
                  Charterer Account
                </label>
                <input
                  value={ChartererAcc}
                  placeholder="Enter Charterer Account"
                  onChange={(e) => setChartererAcc(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Year Of Built"
                />
              </div>
            </div>

            <div className="p-5 flex justify-between xm:flex-wrap gap-5 items-center ">
              
              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Lychan" className="font-semibold">
                  Commission
                </label>
                <input
                  value={Commission}
                  placeholder="Enter Commission"
                  onChange={(e) => setCommission(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Lychan"
                />
              </div>
            </div>

            {/* Name Company */}

            <div className="p-5 flex gap-5 items-center xm:flex-wrap xm:gap-5">
              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Name" className="font-semibold">
                  Name of the Owner
                </label>
                <input
                  value={name}
                  placeholder="Enter Owner Name"
                  onChange={(e) => setName(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Name"
                />
              </div>

              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Company" className="font-semibold">
                  Company of the Owner
                </label>
                <input
                  value={Company}
                  placeholder="Enter Company Name"
                  onChange={(e) => setCompany(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Company"
                />
              </div>
            </div>

            <div className="flex p-5 flex-col gap-1 w-[100%]">
                <label htmlFor="Company Address" className="font-semibold">
                  Company Address of the Owner
                </label>
                <input
                  value={CompanyAddress}
                  placeholder="Enter Company Address"
                  onChange={(e) => setCompanyAddress(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Company"
                />
              </div>

            {/* Email Phone */}
            <div className="p-5 flex gap-5 items-center xm:flex-wrap xm:gap-5">
              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Email" className="font-semibold">
                  Email of the Owner
                </label>
                <input
                  value={Email}
                  
                  placeholder="Enter your Email"
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Email"
                />
              </div>

              <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                <label htmlFor="Mobile No" className="font-semibold">
                  Mobile No Of the Owner
                </label>
                <input
                  value={MobileNO}
                  
                  placeholder="Enter your Mobile"
                  onChange={(e) => setMobileNO(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Mobile No"
                />
              </div>
            </div>

            <div className="p-5 ">
                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="URL" className="font-semibold">
                   URL
                  </label>
                  <input
                    value={Url}
                    onChange={(e) => setUrl(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="url"
                    placeholder="Enter the url"
                  />
                </div>
              </div>
            {/* Brief Description */}
            <div className="p-5">
              <label htmlFor="Brief Description" className="font-semibold">
                Additional Informations
              </label>
              <textarea
                placeholder="More info..."
                value={BriefDescription}
                onChange={(e) => setBriefDescription(e.target.value)}
                rows={5}
                className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                name=""
                id="Brief Description"
              ></textarea>
            </div>

           
            <hr className="text-gray-500 w-full" />
            <div className="p-4">
              <button
                type="submit"
                onClick={(e) => handleSubmitCharter(e)}
                className="bg-green-600 hover:bg-green-500 text-white px-3 py-2 rounded"
              >
                Submit
              </button>
            </div>
          </form>
    </div>
        
        
        </section>
    

    
    {/* Go to Top Button */}
    {isScrolled && (
  <div
    className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
  >
    <div
      className="back-to-top px-4 hover:bg-[#615d91]"
      onClick={scrollToTop}
    >
      <i className="fa-solid fa-arrow-up text-2xl"></i>
    </div>
  </div>
)}
     
    <Footer/>
      
    </div>
  )
}
